var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-icon',{attrs:{"small":"","color":"primary"}},[_vm._v(" mdi-star ")]),_vm._v(" ("+_vm._s(_vm.service.serviceRating)+"/5) - ("+_vm._s(_vm.service.reviewNb === null ? 0 : _vm.service.reviewNb)+" "+_vm._s(_vm.$t("reviewDialog.review"))+") ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }